/**
 * @file blog-progress.js
 *
 */

(function ($, Drupal) {
  "use strict";

  Drupal.behaviors.blogprogress = {
    attach: function (context, settings) {
      var docHeight = $(
          ".single-blog__content-container",
          context
        ).outerHeight(),
        windowHeight = $(window).height(),
        alertHeight =
          $(".block-alertbox").length > 0
            ? $(".block-alertbox", context).outerHeight()
            : 0,
        headerHeight = $("header", context).outerHeight(),
        heroHeight = $(".single-blog__hero", context).outerHeight(),
        offset = alertHeight + headerHeight + heroHeight,
        scrollPercent;
      $(window).scroll(function () {
        scrollPercent =
          (($(window).scrollTop() - offset) / (docHeight - windowHeight)) * 100;

        $(".progress-bar", context).width(scrollPercent + "%");
      });
    },
  };
})(jQuery, Drupal);
